import React from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans, useTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import MDContainer from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import styled from "styled-components";
import Divider from "@material-ui/core/Divider";
import { Link as RouterLink } from "react-router-dom";
import { Route } from "react-router";
import MyPictureSetsPage from "../MyPictureSets/MyPictureSets";
import MyPictureSetPage from "../MyPictureSet/MyPictureSet";
import AddPictureSetPage from "../AddPictureSet/AddPictureSet";
import MyOrdersPage from "../MyOrders/MyOrders";

import PersonIcon from "@material-ui/icons/Person";
import ContactInfoIcon from "@material-ui/icons/PinDrop";
import MyPictureSetsIcon from "@material-ui/icons/Photo";
import OrderHistoryIcon from "@material-ui/icons/History";
import BlockIcon from "@material-ui/icons/Block";
import CommunicationIcon from "@material-ui/icons/Chat";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import MyContactInfoPage from "../MyContactInfo/MyContactInfo";
import ChangePasswordPage from "../ChangePassword/ChangePassword";
import MyCommunicationSettingsPage from "../MyCommunicationSettings/MyCommunicationSettings";
import AppBar from "../../Components/AppBar";
import CancelPicturePackagesPage from "../MyPictureSet/CancelPicturePackagesPage";
import { useAPI } from "../../../../lib/common";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

function ListItemLink(props) {
  const { icon, primary, to } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to],
  );

  return (
    <li>
      <ListItem button component={renderLink}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  );
}

export default () => {
  return (
    <>
      <Route exact path={"/my-account"} component={MyAccountPage} />
      <Route
        exact
        path={"/my-account/contact-info"}
        component={MyContactInfoPage}
      />
      <Route
        exact
        path={"/my-account/communication"}
        component={MyCommunicationSettingsPage}
      />
      <Route
        exact
        path={"/my-account/change-password"}
        component={ChangePasswordPage}
      />
      <Route
        exact
        path={"/my-account/orders/:orderUuid?"}
        component={MyOrdersPage}
      />
      <Route
        exact
        path={"/my-account/add-picture-set"}
        component={AddPictureSetPage}
      />
      <Route
        exact
        path={"/my-account/picture-sets"}
        component={MyPictureSetsPage}
      />
      <Route
        exact
        path={"/my-account/picture-sets/:pictureSetUuid"}
        component={MyPictureSetPage}
      />
      <Route
        exact
        path={"/my-account/cancel-picture-packages"}
        component={CancelPicturePackagesPage}
      />
    </>
  );
};

const MyAccountPage = () => {
  const { t } = useTranslation();
  const [data, loading] = useAPI(
    "/sections/my-account/ajax/get_account_data.php",
  );

  if (loading) {
    return (
      <div>
        <Trans>Fetching account settings</Trans>
      </div>
    );
  }

  const { packageForInspectionSubjects } = data;

  const items = [
    {
      title: t("Change password"),
      icon: <PersonIcon />,
      link: "/my-account/change-password",
    },
    {
      title: t("Update contact information"),
      icon: <ContactInfoIcon />,
      link: "/my-account/contact-info",
    },
    {
      title: t("My picture sets"),
      icon: <MyPictureSetsIcon />,
      link: "/my-account/picture-sets",
    },
    {
      title: t("Order history"),
      icon: <OrderHistoryIcon />,
      link: "/my-account/orders",
    },
  ];
  if (packageForInspectionSubjects.length > 0) {
    items.push({
      title: t("Cancel picture packages"),
      icon: <BlockIcon />,
      link: "/my-account/cancel-picture-packages",
    });
  }

  items.push({
    title: t("Communication"),
    icon: <CommunicationIcon />,
    link: "/my-account/communication",
  });

  return (
    <MobilePage>
      <AppBar />

      <PageHeader>
        <Trans>My account</Trans>
      </PageHeader>

      <Container>
        <MDContainer>
          <Paper>
            <List>
              {items.map((item, index) => {
                return (
                  <>
                    <ListItemLink
                      to={item.link}
                      primary={item.title}
                      icon={item.icon}
                    />
                    {index < items.length - 1 && <Divider />}
                  </>
                );
              })}
            </List>
          </Paper>
        </MDContainer>
      </Container>
    </MobilePage>
  );
};
